export enum METHOD {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export enum ENDPOINT {
  BASE_URL = '',
  Encryption = '/encryption/public-key',
  LOGIN = '/auth/login',
  AZURE_LOGIN = '/auth/azure_login',
  USER_ME = '/user/me',
  USER_SHARE = '/user/compact-list-to-share',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASS = '/forgot-password/reset',
  LOGOUT = '/auth/logout',
  CHANGE_PASS = '/auth/change_password',
  DEPARTMENT = '/tenant',
  DEPARTMENT_UPDATE = '/tenant/:id',
  DEPARTMENT_USAGE_DETAIL = '/tenant/usage-detail',
  DEPARTMENT_EXCEL_USAGE_DETAIL = '/tenant/export-excel-usage-detail',
  DEPARTMENT_PDF_USAGE_DETAIL = '/tenant/export-pdf-usage-detail',
  ASSIGN_DEPARTMENT = 'tenant/assigned-tenant',
  SETTING = '/settings',
  TENANT_ME = '/tenant/my-tenant',
  TEMPLATE_LIST = '/template',
  TEMPLATE_COMPACT_CREATED_BY = '/template/created-by-compact',
  TEMPLATE_PARTNER = '/template/partner-templates',
  TEMPLATE_ASSIGN_LIST = '/template/assigned-template',
  EXPORT_DETAIL_OCR = '/request/:id/export',
  DETAIL_TEMPLATE = '/template/:id',
  DELETE_MULTL_TEMPLATE = '/template/multi',
  REQUEST = '/request',
  UPLOAD_MULTIPLE_IMAGE = '/request/merge-multiple',
  EXPORT_EXCEL = '/request/export',
  USAGE = '/usage',
  USAGE_CURRENT = '/usage/current',
  INVOICE_CURRENT = '/invoice/current',
  EXPORT_USAGE = '/usage/export',
  EXPORT_PDF_USAGE = '/usage/export-pdf',
  GET_DEPARTMENT_COMPACT = '/tenant/compact',
  UPDATE_STATUS_OCR_LIST = '/request/:id/download-status',
  SYNC_BO_TEMPLATES = '/template/sync-bo-templates',
  GET_TEMPLATE_COMPACT = '/template/compact',
  GET_RESULT_REVIEW = '/request/:id/result',
  TEMPLATE_SHARE_MANY_USER = '/template/share-many',
  TEMPLATE_DUPLICATE = '/template/duplicate',
  TEMPLATE_ASSIGN_DEPARTMENT = '/template/assign-tenants-to-template',
  TEMPLATE_ASSIGN = '/template/assign',
  GET_PDF_REVIEW = '/request/:id/document',
  DOCUMENT_SET = '/template/document-set',
  DOCUMENT_SET_ALL = '/template/document-set-list',
  DETAIL_DOCUMENT_SET = '/template/document-set/:id',
  ACTIVATE = '/partner/activate',
  REGISTER_PARTNER = '/partner/register',
  USER = '/user',
  USER_UPDATE = '/user/:id',
  INVOICE = '/invoice',
  INVOICE_DETAIL = '/invoice/:id',
  CONFIRM_PAID = 'invoice/:id/payment',
  INVOICE_EXPORT_DETAIL = '/invoice/:id/export',
  WORK_FLOWS_FORWARDER = '/workflow/forwarder/',
  WORK_FLOWS_REQUEST = '/workflow/request',
  WORK_FLOWS_SHARE_WITH_ADMIN = '/workflow/share-with-admin/',
  WORK_FLOWS_REQUEST_DETAIL = '/workflow/request/:id',
  WORK_FLOWS_REQUEST_SEARCH = '/workflow/request/search',
  WORK_FLOWS_REQUEST_RUN = '/workflow/run-workflow-request/:id',
  WORK_FLOWS_EXPORT = '/workflow/export',
  METADATA_FORWARDER = '/metadata/forwarder',
  METADATA = '/metadata',
  SYNC_BO_WORKFLOWS = '/workflow/sync-bo-workflows',
  PERMISSIONS_PARTNER = '/partner/permissions',
  CANCEL_REQUEST = '/request/:id/cancel',
  RETRY_REQUEST = '/request/:id/retry',
  LOGGING = '/logs',
  MBAL = '/mbal',
  MBAL_DOCSET_MAP = '/mbal/docset-map',
  MBAL_TEMPLATE_MAP = '/mbal/template-map',
  BLOCK_LIMIT_EDIT_HISTORY = '/block-limit-edit-history',
  TEMPLATES_SYNC_FROM_BO = '/template/get-sync-templates-bo',
  SYNC_TEMPLATE = '/template/sync-templates-bo',
  TEMPLATE_EXPORT = '/template/export',
  TEMPLATE_IMPORT_PREVIEW = '/template/import/preview',
  TEMPLATE_IMPORT_COMMIT = '/template/import/commit',
}

export enum LoadingStatus {
  INIT = 'INIT',
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
  LOADING = 'LOADING',
}

export enum STATUS_CODE {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  EMAIL_DOES_NOT_EXISTED = 'EMAIL_DOES_NOT_EXISTED',
  PASSWORD_NOT_MATCH = 'PASSWORD_NOT_MATCH',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  EMAIL_EXISTED = 'EMAIL_EXISTED',
  BLOCK_ACCOUNT = 'BLOCK_ACCOUNT',
  EMAIL_DOES_NOT_WORK = 'EMAIL_DOES_NOT_WORK',
  TOKEN_NOT_FOUND = 'TOKEN_NOT_FOUND',
  USER_NOT_PERMISSION = 'USER_NOT_PERMISSION',
  OLD_PASSWORD_NOT_MATCH = 'OLD_PASSWORD_NOT_MATCH',
  PASSWORD_VS_CURRENT_PASSWORD = 'PASSWORD_VS_CURRENT_PASSWORD',
  TOKEN_INVALID = 'TOKEN_INVALID',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  VALIDATION_NEW_PASSWORD_AND_OLD_PASSWORD = 'VALIDATION_NEW_PASSWORD_AND_OLD_PASSWORD',
  UNAUTHORIZED = 'UNAUTHORIZED',
  REQUEST_CHANGE_PASSWORD = 'REQUEST_CHANGE_PASSWORD',
  ACCOUNT_NOT_ACTIVATED = 'ACCOUNT_NOT_ACTIVATED',
  NOT_FOUND = 'NOT_FOUND',
  FILE_INVALID = 'Invalid excel file',
  USERNAME_PASSWORD_NOT_MATCH = 'USERNAME_PASSWORD_NOT_MATCH',
}

export enum HTTP_CODE {
  OK = 200,
  CREATED = 201,
  ACCEPTED = 202,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  METHOD_NOT_ALLOWED = 405,
  CONFLICT = 409,
  INTERNAL_SERVER_ERROR = 500,
  SERVICE_UNAVAILABLE = 503,
}

export enum API_CODE {
  // request
  UNKNOWN_ERROR = 1000,
  INVADLID_TENANT_CODE = 1001, // user do not have right to access request of other tenant
  OVER_LIMIT_PAGE_PER_REQUEST = 1002,
  INVADLID_QUOTA_CODE = 1003, // quota is run out
  TENANT_EXPIRED_CODE = 1004, // user already expired
  UPLOAD_FAIL = 1005,
  NOT_FOUND = 1006,
  INVALID_FILE_TYPE = 1007, // invalid file type when upload excel file
  TENANT_INACTIVE_CODE = 1008, // tenant is inactive
  PARTNER_EXPIRED_CODE = 1014,
  PARTNER_DEACTIVE = 1015,

  // OCR fail
  OCR_FAIL = 1101,

  // DU fail
  DU_FAIL = 1201,

  // seting - register quota
  INVALID_TENANT_CURRENT_MONTH_PACKAGE = 2002, // error on setting value of curennt month package
  INVALID_TENANT_CURRENT_MONTH_BLOCK = 2003, // error on setting value of curennt month block

  // create user
  USER_EMAIL_EXIST = 3000, // email already exist when create user
  DEPARTMENT_NAME_EXIST = 3001,
  DEPARTMENT_DEACTIVATE, // tenant name already exist when create tenant
}

export const API_MESSAGE = {
  // request
  1001: 'Invalid tenant code!',
  1002: 'Error! Too many pages detected.',
  1003: 'Invalid request quota!',
  1004: 'Tenant is expired',
  1005: 'Upload failed!',
  1006: 'Not found!',
  1007: 'invalid excel file type',

  // OCR fail
  1101: 'OCR failed!',

  // DU fail
  1201: 'DU failed!',

  2002: 'Current month package must be greater or equal this one!',
  2003: 'Current month block must be greater or equal this one!',

  3000: 'Email address already exists in the system!',
  3001: 'Company Name already exists in the system!',
};
